import React, { Component } from 'react';
import styled from 'styled-components';
import media from './MediaQueries';
import { translate } from 'react-polyglot';
import ReactCSSTransitionGroup from 'react-addons-css-transition-group';

const StyledSkinAnalysisWarningsBudget = styled.div`
  color: white;
  background-color: red;
  width: 40px;
  height: 40px;
  border-radius: 30px;
  font-size: 18px;
  font-weight: bold;
  text-align: center;
  position: fixed;
  bottom: 100px;
  left: -15px;
  line-height: 40px;
  cursor: pointer;
`;

const StyledWarningsModal = styled.div`
  font-size: 14px;
  width: 60%;
  background-color: rgba(0, 0, 0, 0.5);
  padding: 20px;
  border-radius: 8px;
  position: absolute;
  left: 20%;
  bottom: 147px;
  color: white;
  max-height: 344px;
  overflow: auto;

  ${media.phone`
    width: 90%;
    left: 6%;
    bottom: 145px;
    padding: 40px 20px;
    font-size: 12px;
    border-radius: 20px 20px 20px 0px;
  `}

  h1 {
    font-size: 18px;
    margin-bottom: 20px;
    ${media.phone`
      font-size: 14px;
    `}
  }

  li {
    margin-left: 18px;
  }

  .closeModal {
    float: right;
    cursor: pointer;
    font-weight: bolder;
    position: absolute;
    top: 20px;
    right: 20px;
    text-align: right;
    width: 50px;
    height: 50px;
  }

  .warningText {
    margin-bottom: 10px;
  }
`;

class SkinAnalysisWarningsWidget extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showWarnings: true,
    };
  }
  render = () => {
    const { cvResults, t } = this.props;
    const { showWarnings } = this.state;
    return (
      <div>
        {cvResults && cvResults.status && cvResults.status.length > 0 && (
          <ReactCSSTransitionGroup
            transitionName="footerSlide"
            transitionAppear={true}
            transitionEnter={true}
            transitionLeave={true}
            transitionAppearTimeout={900}
            transitionLeaveTimeout={900}
            transitionEnterTimeout={900}
          >
            {showWarnings && (
              <StyledWarningsModal className="revieve-selfie-warnings-modal">
                <h1>{t('CV_MESSAGE_Warning_heading')}</h1>
                <div className="warningText">{t('CV_MESSAGE_Warning')}</div>
                <div
                  className="closeModal"
                  onClick={e => {
                    e.stopPropagation();
                    this.setState({ showWarnings: false });
                  }}
                >
                  X
                </div>
                <ul>
                  {cvResults.status.map((warning, i) => {
                    return (
                      <li className="warningText" key={'warning' + i}>
                        {t('CV_CODE_' + warning.idx)}
                      </li>
                    );
                  })}
                </ul>
              </StyledWarningsModal>
            )}
          </ReactCSSTransitionGroup>
        )}
        {cvResults && cvResults.status && cvResults.status.length > 0 && (
          <StyledSkinAnalysisWarningsBudget
            className="revieve-selfie-warnings-budget"
            onClick={() => {
              this.setState({ showWarnings: !showWarnings });
            }}
          >
            !
          </StyledSkinAnalysisWarningsBudget>
        )}
      </div>
    );
  };
}

export default translate()(SkinAnalysisWarningsWidget);



// WEBPACK FOOTER //
// ./src/components/instore/SkinAnalysisWarningsWidget.js